import { Box, styled } from "@mui/material";
const Root = styled(Box, {
  slot: "Root"
})(() => ({
  position: "relative"
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
